import api from 'api/instance';
import { FetchQueryType, FetchResponse } from 'types/common';
import { Status } from 'types/items';
import { toMidnightISOString } from 'utils/dateUtils';

const URL = `${process.env.REACT_APP_API_URL}`;

export const fetchPackages = async (
  params: FetchQueryType & {
    sku?: string[];
    venue?: string[];
    startDate?: Date;
    endDate?: Date;
    status?: number[];
  },
) => {
  const endDate = toMidnightISOString(params.endDate);
  const startDate = toMidnightISOString(params.startDate);

  const { data } = await api.get<FetchResponse<any>>(`${URL}/package/list`, {
    params: {
      ...params,
      startDate,
      endDate,
    },
  });

  return data;
};

export const exportPackagesCsv = async ({
  washHub,
  sku,
  venue,
  status,
  ...payload
}: {
  washHub: string;
  sku?: string[];
  venue?: string[];
  status?: number[];
  startDate?: Date;
  endDate?: Date;
}) => {
  const endDate = toMidnightISOString(payload.endDate);
  const startDate = toMidnightISOString(payload.startDate);

  const { data } = await api.post<any>(`${URL}/package/export-packages`, {
    washHub,
    sku: (sku || [])?.length > 0 ? sku : undefined,
    venue: (venue || [])?.length > 0 ? venue : undefined,
    status: (status || [])?.length > 0 ? status : undefined,
    startDate,
    endDate,
  });

  return data;
};

export const exportCsvPackagesHistory = async ({
  washHub,
  sku,
  venue,
  ...params
}: {
  washHub: string;
  sku?: string[];
  venue?: string[];
  startDate?: Date;
  endDate?: Date;
}) => {
  const endDate = toMidnightISOString(params.endDate);
  const startDate = toMidnightISOString(params.startDate);

  const { data } = await api.post(`${URL}/package/export-packages-trn`, {
    washHub,
    sku: (sku || [])?.length > 0 ? sku : undefined,
    venue: (venue || [])?.length > 0 ? venue : undefined,
    startDate,
    endDate,
  });

  return data as string;
};

export const fetchPackagesByWashHub = async () => {
  const { data } = await api.get(`${URL}/package/get-available-package-by-sku`);

  return data?.item as Array<{
    _id: string;
    count: number;
    packageSku: {
      _id: string;
      name: string;
      description: string;
      type: string;
      isDeleted: boolean;
      caseSku: string;
      items: Array<{
        sku: string;
        quantity: number;
        _id: string;
      }>;
      isSuspended: boolean;
      createdAt: string;
      updatedAt: string;
    };
  }>;
};

export const createReadyPackages = async (payload: {
  washHub: string;
  qaLog?: string;
  usingQaLeftovers?: boolean;
  items: Array<{ sku: string; quantity: number }>;
}) => {
  const { data } = await api.post(
    `${URL}/package/create-ready-packages`,
    payload,
  );

  return data;
};

export const getPackageAvailability = async (
  washHub: string,
  sku: string,
  operation: Status.TRANSFER_OUT | Status.TRANSFER_IN,
) => {
  const { data } = await api.post(
    `${URL}/package/get-availability-for-transfer`,
    {
      sku,
      washHub,
      operation,
    },
  );

  return data?.item as number;
};
